var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgComponents(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.4242 4.93459L14.4237 4.93411L14.4232 4.93363L12.1432 2.74733L11.2004 4.55543L14.8186 8.02494L16.7042 7.12089L14.4242 4.93459ZM17.7527 3.09805L16.545 4.25607L18.1185 5.76481C19.0837 6.69041 18.8197 8.25081 17.5987 8.83621L15.7131 9.74027C15.078 10.0447 14.3341 9.99966 13.7514 9.64703L10.1463 13.104C10.514 13.6627 10.561 14.376 10.2435 14.985L9.30071 16.7931C8.69021 17.9639 7.06292 18.2171 6.09764 17.2915L4.52422 15.7828L3.31656 16.9408L3.11001 17.1388C2.71948 17.5133 2.08632 17.5133 1.6958 17.1388C1.30527 16.7644 1.30527 16.1572 1.6958 15.7828L1.90235 15.5847L3.11001 14.4267L1.53659 12.9179C0.571309 11.9923 0.835382 10.4319 2.05638 9.84653L3.942 8.94248C4.57705 8.638 5.32092 8.68308 5.90364 9.03572L9.50877 5.57878C9.14102 5.02002 9.094 4.30672 9.41153 3.69777L10.3543 1.88966C10.9648 0.718858 12.5921 0.46564 13.5574 1.39124L15.1308 2.89999L16.3385 1.74196L16.545 1.54391C16.9356 1.16943 17.5687 1.16943 17.9593 1.54391C18.3498 1.91838 18.3498 2.52552 17.9593 2.89999L17.7527 3.09805ZM7.35265 10.3584L8.76686 11.7145L12.3024 8.32431L10.8882 6.96823L7.35265 10.3584ZM4.83642 10.6578L2.9508 11.5619L5.23133 13.7486L7.51185 15.9354L8.45466 14.1273L4.83642 10.6578Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComponents);
export default __webpack_public_path__ + "static/media/components.33d57f44.svg";
export { ForwardRef as ReactComponent };